<template>
  <div class="main-bar-4">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <div class="card__category-img">{{ item.sub_category.name }}</div>
            <ImageContainer
              style="overflow: hidden; boreder-radius: 0px"
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__descr">
            <div class="card__category-descr">
              {{ item.sub_category.name }}
            </div>
            <div class="card__title limited-text">{{ item.title }}</div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
          <div class="card__brief">
            <div class="limited-text" style="--snup:5">
              {{ item.brief }}
            </div>
            <div class="data-news-brief">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
      <div class="bg-dark-block"></div>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.card {
  &__img {
    overflow: hidden;
    :deep() .main-image {
      border-radius: 0px;
      overflow: visible;
    }
  }
}
.main-bar-4 {
  padding: 40px 0 0;
  @media screen and (max-width: 992px) {
    width: var(--main-wrapper-width);
  }
}
.card {
  &__brief {
    display: none;
  }
  &__img {
    overflow: hidden;
    :deep() .main-image img {
      border-radius: 0px;
      overflow: visible;
    }
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1rem;
  &__item:nth-child(1),
  &__item:nth-child(2),
  &__item:nth-child(3),
  &__item:nth-child(4),
  &__item:nth-child(5) {
    grid-column: 1 / span 4;
  }
  &__item:nth-child(6) {
    grid-column: 6 / span 7;
    grid-row: 1 / span 5;
  }
  &__item:nth-child(7) {
    grid-column: 1 / span 4;
  }
  &__item:nth-child(8) {
    grid-column: 5 / span 4;
  }
  &__item:nth-child(9) {
    grid-column: 9 / span 4;
  }
  .card-1,
  .card-2,
  .card-3,
  .card-4,
  .card-5 {
    display: flex;
    gap: 1rem;
    margin-bottom: 45px;
    .card__category-img {
      display: none;
    }
    .card__title {
      --snup: 2;
    }
    .card__img {
      flex: 0 0 26%;
      // height: 105px;
      .img {
        padding-bottom: 72%;
      }
    }
    .card__descr {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .data-news {
      margin-top: auto;
    }
  }
  .card-6 {
    position: relative;
    .card__img {
      position: relative;
      // height: 570px;
      .img{
        padding-bottom: 58%;
      }
    }
    .card__category-img {
      position: absolute;
      z-index: 1;
      background: var(--dark-bg);
      padding: 0.2rem;
    }
    .card__descr {
      position: absolute;
      background: var(--dark-bg);
      padding: 0.5rem 1rem;
      max-width: 60%;
      bottom: 0;
      z-index: 1;
    }
    .card__category-descr {
      display: none;
    }
    .data-news {
      text-align: right;
    }
  }
  .card-7,
  .card-8,
  .card-9 {
    position: relative;
    .card__img {
      position: relative;
      // height: 327px;
            .img{
        padding-bottom: 59%;
      }
    }
    .card__category-img {
      position: absolute;
      z-index: 1;
      background: var(--dark-bg);
      padding: 0.2rem;
    }
    .card__descr {
      margin-top: 0.5rem;
    }
    .card__category-descr {
      display: none;
    }
  }
}
@media screen and (max-width: 992px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(4, 1fr) 0px;
    gap: 2rem 1rem;
    &__item:nth-child(1),
    &__item:nth-child(2),
    &__item:nth-child(3),
    &__item:nth-child(4),
    &__item:nth-child(5) {
      grid-column: 8 / span 5;
    }
    &__item:nth-child(6) {
      grid-column: 1 / span 7;
      grid-row: 1 / span 1;
    }
    &__item:nth-child(7) {
      grid-column: 1 / span 7;
      grid-row: 2 / span 1;
    }
    &__item:nth-child(8) {
      grid-column: 1 / span 7;
      grid-row: 3 / span 1;
    }
    &__item:nth-child(9) {
      grid-column: 1 / span 7;
      grid-row: 4 / span 1;
    }
    .card-6,
    .card-7,
    .card-8,
    .card-9 {
      display: flex;
      gap: 1rem;
      .card__img {
        flex: 0 0 50%;
        height: 154px;
      }
      .card__descr {
        margin: 0;
        width: auto;
        position: relative;
        background: transparent;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .card-1,
    .card-2,
    .card-3,
    .card-4,
    .card-5 {
      padding-left: 2.5rem;
      margin-bottom: 0;
      display: block;
      .card__title {
        position: relative;
        --snup: 3;
      }
      .card__img {
        display: none;
      }
    }
    .card-2 {
      transform: translateY(-30%);
    }
    .card-3 {
      transform: translateY(-55%);
    }
    .card-4 {
      transform: translateY(-90%);
    }
    .card-5 {
      transform: translateY(-120%);
    }
    .card-6 {
      .card__descr {
        position: relative;
        background: transparent;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .data-news {
        text-align: left;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .main-bar-4 {
    padding: 0;
    width: 85%;
    margin: 0 auto;
  }
  .card {
    &__img {
      :deep() .main-image {
        border-radius: 0px !important;
        overflow: visible;
      }
    }
    &__category-img {
      padding: 0 0.2rem;
    }
  }
  .grid {
    grid-template-rows: auto;
    &__item:nth-child(1),
    &__item:nth-child(2),
    &__item:nth-child(3),
    &__item:nth-child(4),
    &__item:nth-child(5),
    &__item:nth-child(6),
    &__item:nth-child(7),
    &__item:nth-child(8),
    &__item:nth-child(9) {
      grid-column: 1 / span 12;
      grid-row: auto;
    }

    .card {
      display: flex;
      margin: 0;
      padding: 0;
      gap: 10px;
      transform: translate(0);
      .card__descr {
        // max-width: auto;
        // flex: 0 0 70% !important;
        margin: 0;
        justify-content: space-between;
      }
      .card__category-descr {
        display: none;
      }
      .card__title {
      }
      .card__img {
        position: relative;
        display: block;
        flex: 0 0 30%;
        height: 80px;
      }
      .card__category-img {
        display: block;
        position: absolute;
        background-color: var(--dark-bg);
        z-index: 2;
      }
    }
    .card-4,
    .card-5,
    .card-6 {
      flex-direction: row-reverse;
      text-align: right;
      .card__img {
        text-align: left;
      }
      .data-news {
        text-align: right;
      }
    }
  }
}
</style>
